<template lang='pug'>
.contactUs
	v-e24-nav-bar
	headerResources(:srcImage='img', :tall="tall", h1="Customer Service")
	.content-static-pages.contact
		.inside
			p(v-if="config")
				| For a fast answer to a question, you may first want to consult our
				app-link.contextual-link(to='/faq')
					span: | &nbsp;Frequently Asked Questions&nbsp;
				| section and/or our
				app-link.contextual-link(to='/resources')
					span: | &nbsp;Resources&nbsp;
				| section.
				br
				br
				| For all Customer Service queries that may not be answered there, please email us to:&nbsp;
				a.contextual-link(:href='`mailto:${config.company.emailAddress().address}`')
					span: | Customer Service&nbsp;
				| or call us to: {{ `(${config.company.phoneNumber().areaCode}) ${config.company.phoneNumber().number}` }}
				| or to: {{ navLinks.supportPhone2 }}
				br
				br
				| We pride ourselves on answering your questions as soon as we receive them.
				br
				br
				| We are grateful for your patronage, and we thank you for helping EasyTitle24.com be the best Title 24 Energy Compliance site on the web!
	v-e24-footer(:build="build")
</template>
<script>
import headerResources from '@/commonSite/header.vue'
import imageHeader from '@/img/contact-header.jpg'
import {Organization} from 'janux-people'
import readBuild from '../util/readBuild'

export default {
	name: 'contact-us',
	components: {
		headerResources
	},
	data: function () {
		return {
			build: '',
			img: imageHeader,
			tall: 90,
			config: null,
			navLinks: {}
		}
	},
	mixins: [readBuild],
	mounted () {
		this.build = this.getBuild()
	},
	beforeMount: function () {
		this.navLinks = this.$e24Common.storageService.findItem('navLinks', true)
		// console.debug(`navLinks is `, this.navLinks)
	},
	created () {
		console.log('Created contactus')
		this.config = this.$e24Common.storageService.findItem('config', true)
		this.config.company = Organization.fromJSON(this.config.company)
	}
}
</script>



// WEBPACK FOOTER //
// src/views/Contactus.vue